import * as React from "react";
import type { SVGProps } from "react";
const SvgDismissInCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.293 8.293a1 1 0 1 1 1.414 1.414L13.414 12l2.293 2.293.07.076a1 1 0 0 1-1.408 1.407l-.076-.069L12 13.414l-2.293 2.293-.076.07a1 1 0 0 1-1.407-1.408l.069-.076L10.586 12 8.293 9.707a1 1 0 0 1 1.414-1.414L12 10.586z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 2c5.51 0 10 4.49 10 10s-4.49 10-10 10S2 17.51 2 12 6.49 2 12 2m0 2c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDismissInCircle;
